<template>
  <div class="container">
    <div class="header_logo">
      <div class="top1">
        <router-link to="/"><img class="logo1" src="@/assets/images/sld.jpg" alt=""></router-link>
        <div class="xyonghu">{{$t('welcomeToRegister')}}</div>
      </div>
      <div class="top2">
        <router-link class="login" to="/login">{{$t('login')}}</router-link>
      </div>
    </div>
    <div class="wrapper">
      <div class="main">
        <router-link to="/">
          <div class="logo">
            <img :src="$store.state.config.shop_logo" alt>
          </div>
        </router-link>

      <!-- {{$i18n.locale}} -->

        <div class="title">Register Now</div>
		<div class="annotation">
			<div class="list">
				<li>Creating an account at Sanlida Archery, you can</li>
				<li>√ Shopping with best discount.</li>
				<li>√ Order with Lifetime warranty.</li>
			</div>
		</div>
        <template v-if="$i18n.locale == 'zh'">
          <div class="register-form">
            <code-input
              @getTelPhone="getPhoneValue"
              @getInputError="getInputError"
              @getSmsCode="getSmsCode"
            ></code-input>
            <div class="input-group">
              <i class="icon iconfont iconpassword"></i>
              <input :placeholder="$t('pEnterPwd')"
                v-model="password" class="reg-input password" :type="showPassword?'text':'password'" >
              <i class="icon iconfont"
                :class="showPassword?'iconpassword-view':' iconpassword-not-view'"
                @click="changeInputType"
              ></i>
            </div>
            <div class="error" v-show="showError">
              <i class="icon iconfont iconerror"></i>
              {{errorText}}
            </div>
            <div class="register-btn" @click="handleRegister">{{$t('register')}}</div>
            <div class="tologin">
              <router-link :to="'login'">{{$t('loginTips')}}</router-link>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="register-form">

            <InputGroup icon="el-icon-message" :placeholder="$t('pEenterEmail')" v-model="telphone"></InputGroup>

            <div class="input-group">
              <i class="icon iconfont iconpassword"></i>
              <input :placeholder="$t('pEnterPwd')"
                v-model="password" class="reg-input password" :type="showPassword?'text':'password'" >
            </div>

            <div class="input-group">
              <i class="icon iconfont iconpassword"></i>
              <input placeholder="Confirm Passwords"
                v-model="apassword" class="reg-input password" :type="showPassword?'text':'password'" >
            </div>


            <div class="error" v-show="showError">
              <i class="icon iconfont iconerror"></i>
              {{errorText}}
            </div>
            <div class="register-btn" @click="handleRegister">{{$t('register')}}</div>
            <div class="tologin">
              <router-link :to="'login'">{{$t('loginTips')}}</router-link>
            </div>
          </div>
        </template>


        <div class="tip">
          <label for="agree" class="labind" @click="checked=!checked">
            <i class="icon iconfont" :class="checked?'iconradioed':'iconradio'"></i>
<!--            {{$t('agreeTips')}}
            <a href="javascript:;">{{$t('userAgreement')}}</a> and
            <a href="javascript:;">{{$t('privacyAgreement')}}</a> -->
			Forgot your password or any problem with login, please <router-link :to="'contact'">contact us</router-link>.
          </label>
        </div>
      </div>
    </div>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import LoginInputGroup from "@/components/login/LoginInputGroup.vue";
import CopyRight from "@/components/common/CopyRight.vue";
import { inputCheckPhone, isValid } from "@/utils/index.js";
import { mapActions } from "vuex";

import InputGroup from "@/components/layout/InputGroup.vue";

export default {
  name: "Register",
  components: {
    "code-input": LoginInputGroup,
    CopyRight,
    InputGroup
  },
  props: {},
  data() {
    return {
      telphone: "",
      password: "",
      apassword: '',
      smsCode: "",
      errorText: "",
      checked: true,
      showPassword: false
    };
  },
  watch: {},
  computed: {
    showError() {
      return isValid(this.errorText);
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    changeInputType() {
      this.showPassword = !this.showPassword;
    },
    handleRegister() {

    
      if (!this.checked) {
        return (this.errorText = this.$t('agreeTermsTips'));
      }

      if(this.$i18n.locale == 'en') {
        if(this.password != this.apassword) {
          return (this.errorText = this.$t('pwdCheck'));
        }
        let data = {
          email: this.telphone,
          password: this.password,
          platform: 5
        };

        if(localStorage.getItem('invite')) {
          data.invitecode = localStorage.getItem('invite')
        }
        if(localStorage.getItem('customcode')) {
            data.customcode = localStorage.getItem('customcode')
        }

        this.$api.smsLogin(data).then(res => {
          if (res.status) {
            this.$msg(this.$t('regSuccessful'));
            this.$storage.set("userToken", res.data);
            this.$api.userInfo({}).then(result => {
              if (result.status) {
                this.getUserInfo(result.data);
                this.$storage.set("userInfo", result.data);
				this.facebookAddUser();
              }
            });
            // this.$router.go(-1);

             this.$router.push({
                path: '/center/userInfo'
              })
          } else {
            this.errorText = res.msg;
          }
        });
      } else {
        if (this.checkInputPhone() && this.checkInputCode()) {
          let data = {
            mobile: this.telphone,
            code: this.smsCode,
            password: this.password,
            platform: 5
          };

          if(localStorage.getItem('invite')) {
            data.invitecode = localStorage.getItem('invite')
          }
          if(localStorage.getItem('customcode')) {
              data.customcode = localStorage.getItem('customcode')
          }

          this.$api.smsLogin(data).then(res => {
            if (res.status) {
              this.$msg(this.$t('regSuccessful'));
              this.$storage.set("userToken", res.data);
              this.$api.userInfo({}).then(result => {
                if (result.status) {
                  this.getUserInfo(result.data);
                  this.$storage.set("userInfo", result.data);
					this.facebookAddUser();
                }
              });
                this.$router.push({
                  path: '/center/userInfo'
                })
              // this.$router.go(-1);
            } else {
              this.errorText = res.msg;
            }
          });
        }
      }
    },
	facebookAddUser(){
		let userInfo = this.$storage.get('userInfo');
		let completeRegistration = {
			content_name:this.telphone,
			currency:'USD',
			status:true,
			value:userInfo.id,
		};
		window.fbq('track', 'CompleteRegistration',completeRegistration);
	},
    checkInputPhone() {
      if (!isValid(this.telphone)) {
        this.errorText = this.$t('phoneNotEmpty');
        return false;
      } else if (!inputCheckPhone(this.telphone)) {
        this.errorText = this.$t('phonenumberformatisincorrect');
        return false;
      }
      this.errorText = "";
      return true;
    },
    checkInputPassword() {
      if (!isValid(this.password)) {
        this.errorText = this.$t('pEnterPwd');
        return false;
      }
      return true;
    },
    checkInputCode() {
      if (!isValid(this.smsCode)) {
        this.errorText = this.$t('pEvalidation');
        return false;
      }
      return true;
    },
    //获取子组件手机号
    getPhoneValue(val) {
      this.telphone = val;
    },
    //获取子组件验证码
    getSmsCode(val) {
      this.smsCode = val;
    },
    //获取错位信息
    getInputError(val) {
      this.errorText = val;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.header_logo {
  border-bottom: 2px solid #ea4b49;
  background: #fff;
  padding-top: 35px;
  overflow: hidden;
  padding-bottom: 20px;
  .top1 {
    margin: 0 auto;
    width: 1100px;
    overflow: hidden;
    display: flex;
    align-items: center;
    .logo1 {
      border-right: 1px solid #e5e5e5;
      float: left;
      padding-right: 25px;
    }
    .xyonghu {
      font-weight: normal;
      font-size: 24px;
      padding-left: 25px;
      overflow: hidden;
      font-family: "microsoft yahei";
      color: #585858;
    }
  }
  .top2 {
    margin: 0 auto;
    width: 1100px;
    // overflow: hidden;
    font-size: 16px;
    text-align: right;
    color: #707070;
    .login {
      color: #e64e4d;
    }
  }
}
.container {
  // position: relative;
  .wrapper {
    width: 801px;
    height: 630px;
    // margin: 0 auto;
    background: #fff;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // margin-top: -275px;
    // margin-left: -400px;
    margin: 30px auto;
    .main {
      padding: 40px 0;
      box-sizing: border-box;
      .logo {
        height: 60px;
        margin: 0 auto;
        img {
          display: block;
          width: auto;
          height: 100%;
          margin: 0 auto;
          object-fit: contain;
        }
      }
      .title {
        margin-top:10px;
        text-align: center;
        @include line-height(30px);
        font-size: 21px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .annotation {
        margin-top:10px;
        text-align: center;
		position: relative;
      }
      .annotation .list{
		width:290px;
		margin:0;
		text-align: center;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
      }
      .annotation li{
		text-align: left;
		list-style-type:none;
        @include line-height(24px);
        font-size: 12px;
        font-weight: 0;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.register-form {
  width: 312px;
  margin: 105px auto 0;
  .input-group {
    width: 100%;
    height: 40px;
    margin-bottom: 16px;
    border: 1px solid rgba(220, 220, 220, 1);
    border-radius: 0;
    display: flex;
    align-items: center;
    padding: 5px 0 5px 10px;
    box-sizing: border-box;
    .icon {
      display: inline-block;
      text-align: center;
      margin-right: 6px;
    }
    .reg-input {
      display: block;
      height: 100%;
      flex: 1;
    }
    .code-btn {
      width: 84px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #ea4b49;
      font-weight: 400;
      border-left: 1px solid rgba(220, 220, 220, 1);
    }
  }

  .register-btn {
    width: 312px;
    height: 40px;
    line-height: 40px;
    background: #ea4b49;
    color: #fff;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    margin-top: 30px;
  }
  .tologin {
    font-size: 12px;
    text-align: right;
    line-height: 20px;
    margin: 5px 0;
    a {
      &:hover {
        color: $theme-color;
      }
    }
  }
  .error {
    font-size: 12px;
    color: $theme-color;
    transition: all 0.2s;
  }
}
.tip {
  font-size: 13px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  padding-left: 5px;
  margin-bottom: 40px;
  text-align: center;
  padding-top: 40px;
  .labind {
    display: inline-block;
    padding: 10px 0;
    cursor: pointer;
    .icon {
      width: 24px;
      height: 24px;
      margin-right: 3px;
      margin-top: -3px;
      display: inline-block;
      vertical-align: middle;
      font-size: 24px;
      &.iconradioed {
        color: $theme-color;
      }
    }
    a {
      color: #333;
      font-weight: 550;
    }
  }
  .tologin {
    position: absolute;
    right: 0;
    top: 20px;
    color: #4995e3;
    font-size: 10px;
  }
}
.copyright-wrap {
  // width: auto;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // right: 0;
}
</style>